import { CodeListItem } from 'app/area/indicator-factors/list/types-store';

export const mapCodeParameters = (codeParameters: CodeListItem[], dateFormatter: (date: Date) => string) => {
  return codeParameters?.map(param => {
    const parameters = [
      param?.substance?.value !== 0 && param?.substance?.description,
      param?.indicatorSubstance?.value !== 0 && param?.indicatorSubstance?.description,
      param?.indicatorType?.value !== 0 && param?.indicatorType?.description,
      param?.validFrom && dateFormatter(param?.validFrom),
      param?.location?.value !== 0 && param?.location?.description,
      param?.unit?.value !== 0 && param?.unit?.description,
      param?.source?.value !== 0 && param?.source?.description,
      param?.equipment?.value !== 0 && param?.equipment?.description
    ].filter(p => !!p);
    return parameters.length > 0 && parameters.join(', ');
  }).filter(cp => !!cp) || [];
};
